// mediaTagging/drawRect.js — the rectangle a user is drawing, from the press point and the current mouse point
// (plan bugfix_2026-10-06_permission-tagging, phase polishing). Pure: layer pixels in, layer pixels out.
//
// The mouse point is clamped to the layer on all four sides: outside the picture the box stands at the edge in that
// direction — it reaches the edge even when the mouse left the picture faster than the box followed (User 2026-10-06).

export function clampToLayer(point, size) {
    return {
        x: Math.min(Math.max(point.x, 0), size.width),
        y: Math.min(Math.max(point.y, 0), size.height),
    };
}

// start, point: { x, y } in layer pixels; size: { width, height } of the layer → { l, t, w, h }.
export function drawRect(start, point, size) {
    const a = clampToLayer(start, size);
    const b = clampToLayer(point, size);
    return {
        l: Math.min(a.x, b.x),
        t: Math.min(a.y, b.y),
        w: Math.abs(a.x - b.x),
        h: Math.abs(a.y - b.y),
    };
}

// A press becomes a DRAG once the mouse moved more than `tolerance` px from the press point on either axis — below
// that it is a click (a hand never holds perfectly still). User 2026-10-07: a drag pauses the video, a click toggles it.
export function movedBeyond(start, point, tolerance) {
    return Math.abs(point.x - start.x) > tolerance || Math.abs(point.y - start.y) > tolerance;
}
